import {Card} from '@primer/react-brand'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {renderWithNoMarks} from '../../../utils'
import type {IconLinkItem} from '../../../types'
import {SupportGrid} from './SupportGrid'

export function SupportIconCards({items}: {items: IconLinkItem[]}) {
  return items.map((item, index) => {
    const Octicon = getPrimerIcon(item.fields.icon)
    return (
      <SupportGrid.Item key={item.sys.id} index={index} total={items.length}>
        <Card href={item.fields.href} ctaVariant="arrow">
          {Octicon && <Card.Icon icon={<Octicon />} color="default" hasBackground />}
          {item.fields.eyebrow ? <Card.Label>{item.fields.eyebrow}</Card.Label> : null}
          <Card.Heading>
            {renderWithNoMarks(item.fields.heading)}
            {item.fields.alt ? <span className="sr-only"> {item.fields.alt}</span> : null}
          </Card.Heading>
          <Card.Description>{renderWithNoMarks(item.fields.description)}</Card.Description>
        </Card>
      </SupportGrid.Item>
    )
  })
}
